import 'react-perfect-scrollbar/dist/css/styles.css';
import React from 'react';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'src/components/GlobalStyles';
import 'src/mixins/chartjs';
import theme from 'src/theme';
import routes from 'src/routes';

import Snackbar from "src/components/Snackbar"
import { useUIContext } from "src/provider/UIProvider";



const App = () => {
  const routing = useRoutes(routes);

  const {
    openSnackbars,setOpenSnackbars
  } = useUIContext();

  return (
    <ThemeProvider theme={theme}>
      <Snackbar openSnackbars={openSnackbars} setOpenSnackbars={setOpenSnackbars} />
      <GlobalStyles />
      {routing}
    </ThemeProvider>
  );
};

export default App;
